export class RotationPlaneToolConfig {
}
RotationPlaneToolConfig.A_color = 0x63ADF2;
RotationPlaneToolConfig.B_color = 0x63ADF2;
RotationPlaneToolConfig.C_color = 0x63ADF2;
RotationPlaneToolConfig.D_color = 0x63ADF2;
RotationPlaneToolConfig.ABLine_color = 0x63ADF2;
RotationPlaneToolConfig.BCLine_color = 0x63ADF2;
RotationPlaneToolConfig.CDLine_color = 0x63ADF2;
RotationPlaneToolConfig.DALine_color = 0x63ADF2;
RotationPlaneToolConfig.circle_color = 0x63ADF2;
//# sourceMappingURL=RotationPlaneToolConfig.js.map